/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as _ from 'lodash';

const Grid = (props) => {
  const c = classnames(
    'grid',
    'grid--12',
    'grid--gutters',
    props.horizontalAlign ? `${props.horizontalAlign}-xs` : null,
    props.spacing ? `spacing-${props.spacing}` : null,
    (props.size ? `grid--${props.size}` : '')
  );
  const styles = _.assign({}, {
    alignItems: props.alignItems || null,
    justifyContent: props.justifyContent || null,
    flexWrap: props.flexWrap,
    height: props.height,
    flexDirection: props.flexDirection,
  }, props.style);
  return <div style={styles} className={c}>{props.children}</div>;
};
Grid.propTypes = {
  children: PropTypes.any,
  alignItems: PropTypes.oneOf(['flex-end', 'center', 'flex-start']),
  horizontalAlign: PropTypes.oneOf(['top', 'center', 'bottom']),
  height: PropTypes.string,
  size: PropTypes.number,
  spacing: PropTypes.oneOf(['small', 'medium', 'large']),
  justifyContent: PropTypes.oneOf(['center', 'space-between', 'flex-end']),
  flexWrap: PropTypes.oneOf(['nowrap', 'wrap']),
  flexDirection: PropTypes.oneOf(['column', 'row']),
  style: PropTypes.object,
};
Grid.defaultProps = {
  align: 'auto',
  flexWrap: 'wrap',
};

const VerticalCenterGrid = (props) => (
  <div className="grid grid--12 grid--gutters cmp-grid cmp-grid--vertical">
    {props.children}
  </div>
);
VerticalCenterGrid.propTypes = {
  children: PropTypes.any.isRequired,
};

const Cell = (props) => {
  const styles = _.assign({}, props.style, {
    alignSelf: props.alignSelf,
  });

  if (props.minWidth) {
    styles.flexBasis = `${props.minWidth}px`;
    styles.flexGrow = 1;
    styles.flexShrink = 0;
  } else if (props.width) {
    styles.flexBasis = props.width;
    styles.flexGrow = 0;
    styles.flexShrink = 0;
  }

  return (
    <div style={styles} className={`grid-cell grid-cell--align${props.align}`}>{props.children}</div>
  );
};
Cell.propTypes = {
  children: PropTypes.any,
  align: PropTypes.oneOf(['top', 'bottom', 'center', 'auto']),
  horizontalAlign: PropTypes.oneOf(['left', 'center', 'right']),
  minWidth: PropTypes.number,
  width: PropTypes.string,
  alignSelf: PropTypes.string,
  style: PropTypes.object,
};
Cell.defaultProps = {
  align: 'auto',
};

export { Grid, VerticalCenterGrid, Cell };
